import { Route, Routes } from "react-router";
import { authRoutes, commonLayout, customLayout, publicRoutes } from "./router.link";
import MainLayout from "../layouts/mainLayout";
import AuthLayout from "../layouts/authLayout";
import CustomLayout from "@/layouts/customLayout";
import CommonLayout from "@/layouts/commonLayout";

const ALLRoutes: React.FC = () => {
  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<AuthLayout />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route element={<CustomLayout />}>
          {customLayout.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route element={<CommonLayout />}>
          {commonLayout.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default ALLRoutes;
